import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import {
  AbschnittRequest,
  KategorieAdmin,
  KategorieRequest,
  VorlageRequest
} from '../Models/kategorie-admin.model';

/**
 * Verwaltung der Prüfstruktur (Kategorie → Abschnitt → Prüfpunkt-Vorlage).
 *
 * Die Endpunkte sind serverseitig auf Admin/SuperAdmin beschränkt; die Rechte
 * im Frontend blenden nur zusätzlich aus.
 *
 * Die meisten Aufrufe liefern die betroffene Kategorie vollständig zurück –
 * die Seite muss nach einer Änderung nichts nachladen.
 */
@Injectable({ providedIn: 'root' })
export class KategorieAdminService {
  private apiUrl = environment.apiBaseUrl + '/kategorieadmin';

  constructor(private http: HttpClient) { }

  /** Alle Kategorien samt Struktur, auch inaktive. */
  getAlle(): Observable<KategorieAdmin[]> {
    return this.http.get<KategorieAdmin[]>(this.apiUrl);
  }

  // ── Kategorie ──

  createKategorie(request: KategorieRequest): Observable<KategorieAdmin> {
    return this.http.post<KategorieAdmin>(this.apiUrl, request);
  }

  updateKategorie(id: number, request: KategorieRequest): Observable<KategorieAdmin> {
    return this.http.put<KategorieAdmin>(`${this.apiUrl}/${id}`, request);
  }

  deleteKategorie(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  sortiereKategorien(ids: number[]): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/sortieren`, { ids });
  }
  dupliziereKategorie(id: number): Observable<any> {
    return this.http.post<any>(
      `${environment.apiBaseUrl}/inbetriebnahme/kategorien/${id}/duplizieren`,
      {}
    );
  }

  // ── Abschnitte ──

  createAbschnitt(kategorieId: number, request: AbschnittRequest): Observable<KategorieAdmin> {
    return this.http.post<KategorieAdmin>(`${this.apiUrl}/${kategorieId}/abschnitte`, request);
  }

  updateAbschnitt(abschnittId: number, request: AbschnittRequest): Observable<KategorieAdmin> {
    return this.http.put<KategorieAdmin>(`${this.apiUrl}/abschnitte/${abschnittId}`, request);
  }

  deleteAbschnitt(abschnittId: number): Observable<KategorieAdmin> {
    return this.http.delete<KategorieAdmin>(`${this.apiUrl}/abschnitte/${abschnittId}`);
  }

  sortiereAbschnitte(kategorieId: number, ids: number[]): Observable<KategorieAdmin> {
    return this.http.put<KategorieAdmin>(`${this.apiUrl}/${kategorieId}/abschnitte/sortieren`, { ids });
  }

  // ── Prüfpunkt-Vorlagen ──

  createVorlage(abschnittId: number, request: VorlageRequest): Observable<KategorieAdmin> {
    return this.http.post<KategorieAdmin>(`${this.apiUrl}/abschnitte/${abschnittId}/vorlagen`, request);
  }

  updateVorlage(vorlageId: number, request: VorlageRequest): Observable<KategorieAdmin> {
    return this.http.put<KategorieAdmin>(`${this.apiUrl}/vorlagen/${vorlageId}`, request);
  }

  deleteVorlage(vorlageId: number): Observable<KategorieAdmin> {
    return this.http.delete<KategorieAdmin>(`${this.apiUrl}/vorlagen/${vorlageId}`);
  }

  sortiereVorlagen(abschnittId: number, ids: number[]): Observable<KategorieAdmin> {
    return this.http.put<KategorieAdmin>(`${this.apiUrl}/abschnitte/${abschnittId}/vorlagen/sortieren`, { ids });
  }
}
